export const USA_PROGRAMS = `
  query usaPrograms($filter: FilterUsaProgramInput, $tenant_id: Int!) {
    usaPrograms(filter: $filter, tenant_id: $tenant_id) {
      id
      name
    }
  }
`;
